var youtube = document.querySelectorAll('.embed_media');
for (var i = 0; i < youtube.length; i++) {
    var source = youtube[i].dataset.image;
    var image = new Image();
    image.src = source;
    image.addEventListener('load', function () {
        youtube[i].appendChild(image);
    }(i));

    youtube[i].addEventListener('click', function () {
        var iframe = document.createElement('iframe');
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('src', this.dataset.embed + '?rel=0&showinfo=0&autoplay=1&enablejsapi=1');
        this.innerHTML = '';
        this.appendChild(iframe);
    });
};
